import { render, staticRenderFns } from "./SchoolTotalSectionExportLegend.vue?vue&type=template&id=6041db60&scoped=true&"
import script from "./SchoolTotalSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./SchoolTotalSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041db60",
  null
  
)

export default component.exports